function AclPlugin (AclStorage) {
  this.roles = []
  this.permissions = []

  this.update = function () {
    this.roles = AclStorage.getRoles()
    this.permissions = AclStorage.getPermissions()
  }

  this.update()

  this.isSuperUser = function () {
    const roles = this.roles.filter(role => {
      return role == 'super_admin' || role == 'devs'
    })

    return (roles.length > 0)
  }

  this.hasRole = function (rolesString, userId) {
    const list = this.roles
    const roles = normalizePipes(rolesString)
    return check(list, roles, userId)
  }

  this.hasPermission = (permissionString, userId) => {
    if (this.isSuperUser()) {
      return true
    }
    const list = this.permissions
    const permissions = normalizePipes(permissionString)

    return check(list, permissions, userId)
  }

  /**
   * Verifica se pelo menos uma das permissoes existe
   *
   * @param haystack lista onde serão buscadas as permissoes
   * @param needle lista a ser buscada
   * @param userId opcional verifica se é o usuario logado
   * @returns {boolean} retorna se atende todas as condicoes
   */

  var check = function (haystack, needle, userId) {
    if (haystack == undefined || haystack.length == 0 || needle == undefined)
      return false

    if (userId != undefined) {
      if (userId != AclStorage.getUser()) return false
    }

    return find(haystack, needle) !== undefined
  }

  /**
   * Verifica se pelo menos uma das permissoes existe
   *
   * @param haystack lista onde serão buscadas as permissoes
   * @param needle lista a ser buscada
   * @returns {boolean} se pelo menos 1 dos itens em needle for encontrado
   */

  var find = function (haystack, needle) {
    return needle.find((role) => {
      return haystack.indexOf(role) !== -1
    })
  }

  /**
   * Tranforma string em lista tendo o pipe(|) como separador
   * @param string
   * @returns {[null]}
   */
  var normalizePipes = function (string) {
    return (string.indexOf('|') !== -1) ? string.split('|') : [string]
  }
}

export default AclPlugin


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/aclPlugin.js